import { render } from "./FooterApp.vue?vue&type=template&id=f55d1926&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"

import "./FooterApp.vue?vue&type=style&index=0&id=f55d1926&scoped=true&lang=css"

import exportComponent from "D:\\Web\\Coonfia\\Mantenedor\\coonfia-mantenedor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55d1926"]])

export default __exports__